import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Stethoscope, Salad, Waves, Flame, Syringe } from "lucide-react";
import { useNavigate } from "react-router-dom";
const Programs = () => {
  const navigate = useNavigate();
  const scrollToBooking = () => {
    document.getElementById('book-session')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const goToPrograms = () => {
    navigate('/programs');
  };
  const goToProgramSection = (sectionId: string) => {
    navigate(`/programs#${sectionId}`);
  };
  const programs = [{
    id: "lifestyle",
    icon: Stethoscope,
    title: "Lifestyle Diseases",
    description: "Comprehensive support for cardiovascular health, blood pressure management, fatty liver, and high uric acid. Take control of your metabolic health through personalized nutrition strategies."
  }, {
    id: "gut",
    icon: Salad,
    title: "Gut Health",
    description: "Address acid reflux, IBS, IBD, H. Pylori, leaky gut, gastritis, and gut dysbiosis. Restore digestive balance and heal your gut from within using targeted functional nutrition protocols."
  }, {
    id: "hormonal",
    icon: Waves,
    title: "Hormonal Balance",
    description: "Specialized programs for PCOD/PCOS and thyroid imbalances. Balance your hormones naturally through nutrition, lifestyle modifications, and evidence-based functional approaches."
  }, {
    id: "inflammation",
    icon: Flame,
    title: "Understanding Inflammation",
    description: "Comprehensive inflammatory marker assessment and management. Learn to identify root causes of inflammation and implement anti-inflammatory nutrition strategies for lasting health."
  }, {
    id: "diabetes",
    icon: Syringe,
    title: "Diabetes Management",
    description: "Expert guidance for prediabetes and insulin resistance. Reverse metabolic dysfunction through personalized meal planning, blood sugar optimization, and sustainable lifestyle changes."
  }];
  return <section className="section-padding container-custom bg-secondary/30">
      <div className="space-y-8 sm:space-y-12">
        <div className="text-center space-y-3 sm:space-y-4 max-w-3xl mx-auto px-4">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-foreground">
            What is Functional Nutrition?
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground leading-relaxed">
            Functional nutrition is a personalized, science-based approach that looks beyond symptoms to identify and address the root causes of health imbalances. By understanding your unique biochemistry, lifestyle, and health history, we create targeted nutrition strategies that support your body's natural healing processes.
          </p>
        </div>

        <div className="space-y-6 sm:space-y-8 max-w-6xl mx-auto px-4">
          {/* First 3 cards - responsive grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {programs.slice(0, 3).map((program, index) => <Card key={index} onClick={() => goToProgramSection(program.id)} className="card-enhanced p-6 sm:p-8 flex flex-col space-y-4 hover:shadow-xl transition-all duration-300 hover:scale-105 border-border cursor-pointer h-full">
                
                <h3 className="text-lg sm:text-xl font-semibold text-card-foreground flex-shrink-0">
                  {program.title}
                </h3>
                <p className="text-sm sm:text-base text-muted-foreground leading-relaxed flex-grow">
                  {program.description}
                </p>
              </Card>)}
          </div>
          
          {/* Last 2 cards - centered on larger screens */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8 lg:max-w-2xl lg:mx-auto">
            {programs.slice(3, 5).map((program, index) => <Card key={index + 3} onClick={() => goToProgramSection(program.id)} className="card-enhanced p-6 sm:p-8 flex flex-col space-y-4 hover:shadow-xl transition-all duration-300 hover:scale-105 border-border cursor-pointer h-full">
                
                <h3 className="text-lg sm:text-xl font-semibold text-card-foreground flex-shrink-0">
                  {program.title}
                </h3>
                <p className="text-sm sm:text-base text-muted-foreground leading-relaxed flex-grow">
                  {program.description}
                </p>
              </Card>)}
          </div>
        </div>

        <div className="text-center px-4">
          <Button onClick={goToPrograms} size="lg" className="bg-accent hover:bg-accent/90 text-accent-foreground px-6 sm:px-8 py-6 w-full sm:w-auto min-h-[48px] text-base sm:text-lg">
            Explore Programs
          </Button>
        </div>
      </div>
    </section>;
};
export default Programs;